import React from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Sidebar from '../../components/Sidebar/Sidebar';
import { useNavigate } from 'react-router-dom';
import { useGlobalContext } from '../../context/Context';
import { FaChevronLeft } from 'react-icons/fa';
import { useState } from 'react';
import axios from 'axios';
import { useEffect } from 'react';
import Loader from '../../components/Loader/Loader';
import 'react-loading-skeleton/dist/skeleton.css';
import {
  CreatePopup,
  DeletePopups,
  UpdatePopup,
} from '../../components/Modals/Modals';
import { toast } from 'react-toastify';

const Popups = () => {
  const navigate = useNavigate();
  const { showProfileModal, baseURL } = useGlobalContext();
  const [loading, setLoading] = useState(true);
  const [updatePopup, setUpdatePopup] = useState(false);
  const [popupId, setPopupId] = useState(``);
  const [createPopup, setCreatePopup] = useState(false);
  const [deletePopups, setDeletePopups] = useState(false);
  const [popups, setPopups] = useState([]);
  const { token } = JSON.parse(sessionStorage.getItem(`adminData`));

  //   GET ALL POPUPS
  const getPopups = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(`${baseURL}/popups`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setPopups(data.popups);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPopups();
    // eslint-disable-next-line
  }, [updatePopup]);

  const deletePopup = async (id) => {
    try {
      const { data } = await axios.delete(`${baseURL}/popups/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success(data.msg);
      getPopups();
    } catch (error) {
      toast.error(error.response.data.msg);
    }
  };

  return (
    <main className='pop-ups-page'>
      <Navbar category={`Management >`} currentPage={`Pop-Ups`} />
      <Sidebar activePage={16} />

      <div className={`main-content ${showProfileModal ? `back` : null}`}>
        <div className='links-btn'>
          <FaChevronLeft onClick={() => navigate(`/dashboard`)} />
          <h2 className='title'>Pop-Ups</h2>
        </div>

        <div className='create-del-btns'>
          <button className='primary' onClick={() => setCreatePopup(true)}>
            Create Pop-up
          </button>
          <button className='red' onClick={() => setDeletePopups(true)}>
            Delete All Pop-ups
          </button>
        </div>

        {loading ? (
          <div className='loader-container'>
            <Loader />
          </div>
        ) : (
          <>
            {popups.map((popup, popupIndex) => {
              const { link, image, _id } = popup;
              return (
                <div className='link-details' key={popupIndex}>
                  <h3 className='title'>Pop-up {popupIndex + 1} Details</h3>
                  <div className='form-control'>
                    <label htmlFor=''>Pop-up Link</label>
                    <h3>{link}</h3>
                  </div>

                  <div className='form-control'>
                    <label htmlFor=''>Pop-up Image</label>
                    <div className='img'>
                      <img
                        src={`https://api.crspredictions.com${image}`}
                        alt=''
                      />
                    </div>
                  </div>
                  <div className='btns'>
                    <button
                      className='primary'
                      onClick={() => {
                        setPopupId(_id);
                        setUpdatePopup(true);
                      }}
                    >
                      Update Pop-up
                    </button>
                    <button
                      className='red'
                      onClick={() => {
                        deletePopup(_id);
                      }}
                    >
                      Delete Pop-up
                    </button>
                  </div>
                </div>
              );
            })}
          </>
        )}
      </div>
      {createPopup && (
        <CreatePopup dismissFunc={setCreatePopup} refreshFunc={getPopups} />
      )}
      {updatePopup && (
        <UpdatePopup popupId={popupId} dismissFunc={setUpdatePopup} />
      )}
      {deletePopups && (
        <DeletePopups dismissFunc={setDeletePopups} refreshFunc={getPopups} />
      )}
    </main>
  );
};

export default Popups;
